import { render, staticRenderFns } from "./createModule.vue?vue&type=template&id=241913aa&"
import script from "./createModule.vue?vue&type=script&lang=ts&"
export * from "./createModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports